export default "__VITE_ASSET__Br$QPnwY__"